var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.5 20.2484H22.5M13.5 20.2484V3.74841C13.5 3.5495 13.421 3.35874 13.2803 3.21808 13.1397 3.07743 12.9489 2.99841 12.75 2.99841H3.75C3.55109 2.99841 3.36032 3.07743 3.21967 3.21808 3.07902 3.35874 3 3.5495 3 3.74841V20.2484M21 20.2484V9.74841C21 9.5495 20.921 9.35874 20.7803 9.21808 20.6397 9.07743 20.4489 8.99841 20.25 8.99841H13.5M6 6.74841H9M7.5 12.7484H10.5M6 16.4984H9M16.5 16.4984H18M16.5 12.7484H18", stroke: "#222429", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});